import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const Dot = ({ ok, label }) => (
  <span data-testid={`health-${label.toLowerCase()}`} className="flex items-center gap-1.5">
    <span className={`w-2 h-2 rounded-full ${ok === null ? "bg-gray-300" : ok ? "bg-emerald-500 animate-pulse" : "bg-red-500"}`} />
    <span className={ok === false ? "text-red-600 font-semibold" : "text-[#4A4A4A]"}>{label}</span>
  </span>
);

const ModeBadge = ({ mode, label, shared }) => (
  <span data-testid={`payments-health-${label.toLowerCase()}`} className={`flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-[10px] font-semibold tracking-[0.08em] uppercase ${mode === "live" ? "text-emerald-700 border-emerald-200 bg-emerald-50" : "text-amber-700 border-amber-300 bg-amber-50"}`}>
    <span className={`w-2 h-2 rounded-full ${mode === "live" ? "bg-emerald-500" : "bg-amber-500 animate-pulse"}`} />
    {label}: {mode === "live" ? "LIVE" : "TEST"}{shared ? " (shared key)" : ""}
  </span>
);

export default function ApiStatus() {
  const [health, setHealth] = useState(null);
  const [down, setDown] = useState(false);
  const [payments, setPayments] = useState(null);

  useEffect(() => {
    api.get("/admin/payments-health", { timeout: 10000 }).then(({ data }) => setPayments(data)).catch(() => {});
  }, []);

  useEffect(() => {
    let alive = true;
    const ping = () =>
      api.get("/health", { timeout: 10000 })
        .then(({ data }) => { if (alive) { setHealth(data); setDown(false); } })
        .catch(() => { if (alive) setDown(true); });
    ping();
    const t = setInterval(ping, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (down) {
    return (
      <p data-testid="api-status-line" className="mt-1 flex items-center gap-2 text-xs font-ui">
        <span className="w-2 h-2 rounded-full bg-red-500" />
        <span className="text-red-600 font-semibold">API offline — bookings are down, check the server</span>
      </p>
    );
  }

  return (
    <p data-testid="api-status-line" className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs font-ui">
      {!health && <span className="text-[#4A4A4A]">Checking systems…</span>}
      {health && (
        <>
          <Dot ok={health.api === "ok"} label="API" />
          <Dot ok={health.mongodb === "ok"} label="Database" />
          <Dot ok={health.smtp === "ok"} label="Email" />
          <Dot ok={health.paypal === "ok"} label="Payments" />
          <Dot ok={health.storage === "ok"} label="Storage" />
          {payments && (
            <>
              <ModeBadge mode={payments.stripe.mode} shared={payments.stripe.shared_test_key} label="Stripe" />
              <ModeBadge mode={payments.paypal.mode} label="PayPal" />
            </>
          )}
          {(health.mongodb !== "ok" || health.smtp !== "ok" || health.paypal !== "ok") && (
            <span className="text-red-600 font-semibold">— action needed, check the server</span>
          )}
        </>
      )}
    </p>
  );
}
